import React, { useEffect } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { fetchSpin } from "../../../actions/spinTheWheelOverview";

import "../Question.scss";
import { ReactSVG } from "react-svg";
import { Link } from "react-router-dom";
import { DateTimeFormat } from "../../../helpers/utils";

const SpinPage = () => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const { status, spin } = useSelector((state) => state.fetchSpin);

	useEffect(() => {
		if (id) {
			dispatch(fetchSpin(id));
		}
	}, [id]);

	return (
		<div id="question-container">
			<div className="page-header">
				<h2 className="page-header-title">Spin The Wheel Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/spin-the-wheel/overview">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Customer No</label>
										<div className="text">{spin.customer_no}</div>
									</div>
									<div className="details-item">
										<label>Winner Email</label>
										<div className="text">{spin.winner_email}</div>
									</div>
									<div className="details-item">
										<label>Game</label>
										<div className="text">
											<Link to={`/spin-the-wheel/games/${spin.game.id}`}>
												{spin.game.name}
											</Link>
										</div>
									</div>
									<div className="details-item">
										<label>Reward</label>
										<div className="text">
											<Link to={`/spin-the-wheel/rewards/${spin.reward.id}`}>
												{spin.reward && spin.reward.name}
											</Link>
										</div>
									</div>
									<div className="details-item">
										<label>Redeem Status</label>
										<div className="text text-capitalize">
											{spin.redeem_status}
										</div>
									</div>
									<div className="details-item">
										<label>Is Winner</label>
										<div className="text">
											{spin.is_winner === true ? "Yes" : "No"}
										</div>
									</div>
									<div className="details-item">
										<label>Created At</label>
										<div className="text">
											{DateTimeFormat(spin.created_at)}
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text">
											{DateTimeFormat(spin.updated_at)}
										</div>
									</div>
									{spin.image_url && (
										<div className="details-item">
											<label>Image</label>
											<div className="text">
												<img src={spin.image_url} alt="" />
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default SpinPage;
